// Contacto.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ContactSection.css';

const Contacto = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: ''
  });
  const [status, setStatus] = useState({
    submitted: false,
    submitting: false,
    info: { error: false, msg: null }
  });

  // Scroll al inicio cuando se monta el componente
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validar que todos los campos estén llenos
    if (!formData.nombre || !formData.email || !formData.telefono || !formData.mensaje) {
      setStatus({
        submitted: false,
        submitting: false,
        info: { error: true, msg: 'Por favor complete todos los campos.' }
      });
      return;
    }
    
    // Mostrar sección de opciones de correo
    setStatus({
      submitted: true,
      submitting: false,
      info: { error: false, msg: 'Por favor, seleccione cómo desea enviar su mensaje:' }
    });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const enviarPorCorreo = (tipo) => {
    const destinatario = "dra.gladysquintero@gmail.com"; // Reemplaza con tu correo real
    const asunto = "Nuevo mensaje de contacto";
    const cuerpo = `
      Nombre: ${formData.nombre}
      Email: ${formData.email}
      Teléfono: ${formData.telefono}
      Mensaje: ${formData.mensaje}
    `;
    
    let emailUrl = '';
    
    switch(tipo) {
      case 'gmail':
        emailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(destinatario)}&su=${encodeURIComponent(asunto)}&body=${encodeURIComponent(cuerpo)}`;
        break;
      case 'outlook':
        emailUrl = `https://outlook.live.com/mail/0/deeplink/compose?to=${encodeURIComponent(destinatario)}&subject=${encodeURIComponent(asunto)}&body=${encodeURIComponent(cuerpo)}`;
        break;
      case 'yahoo':
        emailUrl = `https://compose.mail.yahoo.com/?to=${encodeURIComponent(destinatario)}&subject=${encodeURIComponent(asunto)}&body=${encodeURIComponent(cuerpo)}`;
        break;
      default:
        emailUrl = `mailto:${encodeURIComponent(destinatario)}?subject=${encodeURIComponent(asunto)}&body=${encodeURIComponent(cuerpo)}`;
    }
    
    window.open(emailUrl, '_blank');
    
    // Resetear formulario después de enviar
    setFormData({ 
      nombre: '', 
      email: '', 
      telefono: '', 
      mensaje: '' 
    });
  };

  return (
    <div className="contact-wrapper">
      <div className="contact-container">
        <section className="contact-header">
          {/* Enlace para volver */}
          <Link to="/" className="volver-btn">
            ← Volver
          </Link>
          
          <h1>Contacto</h1>
          <h2>Dra. Gladys Eugenia Quintero</h2>
          <p>
            Para obtener más información sobre consultas, servicios o tratamientos con la Dra. Gladys Eugenia Quintero, 
            complete el formulario y la responderemos a la brevedad.
          </p>
        </section>

        <div className="contact-content">
          {/* Formulario (70%) */}
          <form className="contact-form" onSubmit={handleSubmit}>
            <h3>Formulario de Contacto</h3>
            
            <div className="form-group">
              <label htmlFor="nombre">Nombre completo</label>
              <input className='campos' 
                type="text"
                id="nombre"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Correo electrónico</label>
              <input className='campos' 
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="telefono">Teléfono</label>
              <input className="campos" 
                type="tel"
                id="telefono"
                name="telefono"
                value={formData.telefono}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="mensaje">Mensaje</label>
              <textarea className="campos"
                id="mensaje"
                name="mensaje"
                rows="5"
                value={formData.mensaje}
                onChange={handleChange}
                required
              />
            </div>

            {status.info.error && (
              <div className="error-message">
                {status.info.msg}
              </div>
            )}
            
            {status.submitted && !status.info.error && (
              <div className="success-message">
                {status.info.msg}
              </div>
            )}

            <button 
              type="submit" 
              disabled={status.submitting}
            >
              {status.submitting ? 'Enviando...' : 'Enviar mensaje'}
            </button>
            
            {/* Opciones para enviar por diferentes clientes de correo */}
            {status.submitted && !status.info.error && (
              <div className="email-options" style={{ marginTop: '15px', textAlign: 'center' }}>
                <p style={{ fontSize: '0.9em', marginBottom: '10px' }}>Elija su cliente de correo preferido:</p>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', flexWrap: 'wrap' }}>
                  <button 
                    type="button"
                    onClick={() => enviarPorCorreo('gmail')}
                    style={{ 
                      background: '#DB4437', 
                      color: 'white',
                      border: 'none',
                      padding: '8px 15px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px'
                    }}
                  >
                    <span style={{ fontWeight: 'bold' }}>Gmail</span>
                  </button>

                  <button 
                    type="button"
                    onClick={() => enviarPorCorreo('outlook')}
                    style={{ 
                      background: '#0078D4', 
                      color: 'white',
                      border: 'none',
                      padding: '8px 15px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px'
                    }}
                  >
                    <span style={{ fontWeight: 'bold' }}>Outlook</span>
                  </button>

                  <button 
                    type="button"
                    onClick={() => enviarPorCorreo('yahoo')}
                    style={{ 
                      background: '#400090', 
                      color: 'white',
                      border: 'none',
                      padding: '8px 15px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px'
                    }}
                  >
                    <span style={{ fontWeight: 'bold' }}>Yahoo Mail</span>
                  </button>
                </div>
              </div>
            )}
          </form>

          {/* Información y Mapa (30%) */}
          <div className="contact-info">
            <div className="office-location">
              <h3>Nuestra ubicación</h3>
              <p>
                <strong>Dirección:</strong> cra 23 #72-05 barrio milan<br />
                Manizales, Colombia
              </p>
              
              <div className="map-container">
                <iframe
                  title="Ubicación del consultorio"
                  src="https://www.google.com/maps/embed?pb=!3m2!1ses!2sco!4v1741645629033!5m2!1ses!2sco!6m8!1m7!1sgvDVlYCeJck2JEtef6Hhtg!2m2!1d5.049458232870691!2d-75.48292502079889!3f99.57997!4f0!5f0.7820865974627469"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>

            <div className="contact-methods">
              <div className="contact-item">
                <h4>Horario de atención</h4>
                <p>
                  Lunes a Viernes<br />
                  8:00 am - 7:00 pm<br />
                  Sábados<br />
                  8:00 am - 2:00 pm
                </p>
              </div>

              <div className="contact-item">
                <h4>Teléfonos</h4>
                <p>
                  <strong>Móvil:</strong> 300 107 9888
                </p>
              </div>

              <div className="contact-item">
                <h4>WhatsApp</h4>
                <p>
                  300 107 9888<br />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contacto;